import React from 'react';
import { Form } from 'antd';
import TeamsSelector from './TeamsSelector';

interface Team {
  id: string;
  name: string;
  color?: string;
  permissions?: {
    is_create?: boolean;
    is_update?: boolean;
  };
  disabled?: boolean;
}

interface TeamSelectFieldProps {
  name: string;
  allTeams: Team[];
  isEdit: boolean;
  onTeamChange: (teams: Team[]) => void;
  selectedTeamIds: string[];
  onSearch?: (value: string) => void;
  teamsSearch?: string;
}

const TeamSelectField: React.FC<TeamSelectFieldProps> = ({
  name,
  allTeams,
  isEdit,
  onTeamChange,
  selectedTeamIds = [],
  onSearch,
  teamsSearch = '',
}) => {
  const form = Form.useFormInstance();
  const selected = Form.useWatch(['teams', name, 'team'], form);

  const filteredTeams =
    allTeams?.map((team) => ({
      ...team,
      label: team.name,
      value: team.id,
      disabled: selectedTeamIds.includes(team.id),
    })) || [];

  return (
    <TeamsSelector
      teamsOptions={filteredTeams}
      selectedTeams={selected ? [selected] : []}
      onChange={(val: Team[]) => {
        form.setFieldValue(['teams', name, 'team'], val[0]);
        onTeamChange(val);
      }}
      singleSelect={true}
      formState={isEdit === true ? 'edit' : 'add'}
      onSearch={onSearch}
      teamsSearch={teamsSearch}
    />
  );
};

export default TeamSelectField;
